import Footer from '@components/Footer/Footer';
import Header from '@components/Header/Header';
import Slider from '@components/Slider/Slider';
import TeamCard from '@components/TeamCard/TeamCard';
import useIsMobile from '@hooks/useIsMobile';
import { useState } from 'react';
import advisors from 'src/data/advisors.json';
import team from 'src/data/team.json';
import { SlidesTypeEnum } from 'src/types';

import './Team.css';

const Team = () => {
	const [slidesType] = useState<SlidesTypeEnum>(SlidesTypeEnum.TEAM);
	const slides = slidesType === SlidesTypeEnum.TEAM ? team : advisors;
	const isMobile = useIsMobile();
	return (
		<div id="team" className="page">
			<Header />
			<div className="wrapper">
				{/* <SlidesSelector slidesType={slidesType} handleSlides={setSlides} /> */}
				{!isMobile && (
					<Slider hasIndicators={false} hasNavigation={false}>
						{slides?.length && slides?.map((s, i) => <TeamCard key={s.id + i} slide={s} isCurrent={false} />)}
					</Slider>
				)}
			</div>
			{isMobile && (
				<section className="slides-block">
					{slides?.length && slides?.map((s, i) => <TeamCard key={s.id + i} slide={s} isCurrent={false} />)}
				</section>
			)}
			<Footer />
		</div>
	);
};

export default Team;
